module.exports = __webpack_public_path__ + "static/media/subGoogle2.8ec8d84e.png";